import React from "react";
import { Container, Skeleton, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { columns } from "./deliverersDeliveredHeaders.js";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import styles from "./lotsDeliveredTableStyles.js";
import { formatCurrency } from '../../../utils/Format.js';

const DeliverersDeliveredTable = ({ guides = [], isLoading }) => {
  const rows = guides?.map((guide, index) => ({
    id: guide.id_guide,
    tracking_code: guide.tracking_code,
    recipient_name: guide.recipient_name,
    payment_method: guide.payment_method === '' ? 'Sin método de pago' : guide.payment_method,
    amount: formatCurrency(guide.amount),
  }));

  return (
    <Container sx={styles.mainContainer} style={{ padding: "0" }}>
      {isLoading ? (
        <Container sx={styles.skeletonMainContainer}>
          <Container sx={styles.skeletonSecondaryContainer}>
            <Skeleton variant="rounded" width={'25%'} height={40} />
            <Skeleton variant="rounded" width={'25%'} height={40} />
            <Skeleton variant="rounded" width={'25%'} height={40} />
            <Skeleton variant="rounded" width={'25%'} height={40} />
          </Container>
          <Container sx={styles.skeletonSecondaryContainer}>
            <Skeleton variant="rounded" width={'25%'} height={300} />
            <Skeleton variant="rounded" width={'25%'} height={300} />
            <Skeleton variant="rounded" width={'25%'} height={300} />
            <Skeleton variant="rounded" width={'25%'} height={300} />
          </Container>
        </Container>
      ) : (
        <DataGrid
          autoHeight
          disableColumnFilter
          rows={rows}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          getRowHeight={() => 'auto'} 
          sx={{
            '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { 
              py: '8px', 
              display: 'flex', 
              alignItems: 'center' 
            },
            '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { 
              py: '6px', 
              display: 'flex', 
              alignItems: 'center' 
            },
            '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { 
              py: '22px', 
              display: 'flex', 
              alignItems: 'center' 
            },
          }}
          pageSizeOptions={[10, 20, 50, 100]}
          disableColumnMenu={true}
          disableSelectionOnClick={true}
          localeText={{
            noRowsLabel: (
              <NoResultsComponent message={"No se encontrarón guías"} />
            ),
          }}
        />
      )}
    </Container>
  );
};

const NoResultsComponent = ({ message }) => (
  <Container sx={styles.noDataContainer}>
    <SearchOffIcon sx={styles.noDataIcon} />
    <Typography sx={styles.noDataTitle}>{message}</Typography>
  </Container>
);

export default DeliverersDeliveredTable;
